const CREDENTIALS_MODEL_TEMPLATE = {
  username: null,
  password: null,
}

const REGISTRATION_MODEL_TEMPLATE = {
  firstName: null,
  lastName: null,
  username: null,
  password: null,
  passwordRetype: null,
  agreeWithTerms: false,
  isClient: true,
}

export { CREDENTIALS_MODEL_TEMPLATE, REGISTRATION_MODEL_TEMPLATE }
